import React from 'react';

const ContactLinkedIn = () => {
  return (
    <svg width="19" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_165_177)">
      <path d="M14.8073 14.5612H12.3639V10.7326C12.3639 9.81955 12.3454 8.64461 11.0907 8.64461C9.81675 8.64461 9.62219 9.63805 9.62219 10.6652V14.5612H7.17881V6.68799H9.52594V7.76118H9.55756C9.8855 7.14243 10.683 6.4893 11.8744 6.4893C14.3501 6.4893 14.808 8.11868 14.808 10.2396V14.5612H14.8073ZM4.41919 5.61068C3.63269 5.61068 3.00087 4.97405 3.00087 4.19099C3.00087 3.40861 3.63337 2.77268 4.41919 2.77268C5.20294 2.77268 5.83819 3.40861 5.83819 4.19099C5.83819 4.97405 5.20225 5.61068 4.41919 5.61068ZM5.64431 14.5612H3.19406V6.68799H5.64431V14.5612ZM16.0297 0.500488H1.96756C1.2945 0.500488 0.75 1.03261 0.75 1.68918V15.8118C0.75 16.4691 1.2945 17.0005 1.96756 17.0005H16.0276C16.7 17.0005 17.25 16.4691 17.25 15.8118V1.68918C17.25 1.03261 16.7 0.500488 16.0276 0.500488H16.0297Z" fill="#5F6177"/>
      </g>
      <defs>
      <clipPath id="clip0_165_177">
      <rect width="17" height="17" fill="white" transform="translate(0.75 0.500488)"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default ContactLinkedIn;